import Vue from 'vue';

export const BXLoader = Vue.extend({
    data: () => ({
        message: '',
        awaiting: 1
    }),
    render: function (h) {
        return (
            <div class="bx-loader">
                <div class="bx-loader-content">
                    <svg class="bx-loader-spinner fa-pulse" viewBox="0 0 512 512" fill="#324A6D">
                        <path
                            d="M108.92 355.08a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM256 416a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm208-208a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm-60.92 147.08a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0-198.16a48 48 0 1 0-48-48 48 48 0 0 0 48 48z"/>
                        <path opacity=".4"
                              d="M108.92 60.92a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM48 208a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM256 0a48 48 0 1 0 48 48 48 48 0 0 0-48-48z"/>
                    </svg>
                    <div class="bx-loader-message">
                        {this.message}
                    </div>
                </div>
            </div>
        )
    }
});
